// extracted by mini-css-extract-plugin
module.exports = {"recommendLinks__title":"recommendLinks__title","recommendLinks__list":"recommendLinks__list","recommendLinks__link":"recommendLinks__link"};